import Navbar from "../../components/common/Navbar.js"
import Footer from "../../components/common/Footer.js"
import { FC } from "react"
import styled from "styled-components"
import { Tab, Tabs, TabList, TabPanel } from "react-tabs"
import "react-tabs/style/react-tabs.css"
import UserTable from "../../components/admin/UserTable"
import LeagueTable from "../../components/admin/LeagueTable"
import TeamTable from "../../components/admin/TeamTable"
import LeaguesTables from "../../components/admin/Leagues"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUser, faUsers, faTrophy, faTools, faHistory } from "@fortawesome/free-solid-svg-icons"
import { useUser } from "../../context/useUser"
import ActivityTable from "../../components/admin/ActivityTable"

const Admin: FC = () => {
  const { user } = useUser()

  return (
    <>
      <Navbar />
      <PageContainer>
        <StyledTabs defaultIndex={4}>
          <TabList>
            {user && user.isAdmin ? (
              <>
                <Tab>
                  <FontAwesomeIcon icon={faUser} /> Users
                </Tab>
                <Tab>
                  <FontAwesomeIcon icon={faUsers} /> Teams
                </Tab>
                <Tab>
                  <FontAwesomeIcon icon={faTrophy} /> Leagues
                </Tab>
                <Tab>
                  <FontAwesomeIcon icon={faHistory} /> Activity
                </Tab>
              </>
            ) : null}
            <Tab>
              <FontAwesomeIcon icon={faTools} /> Manage League
            </Tab>
          </TabList>
          {user && user.isAdmin ? (
            <>
              <TabPanel>
                <UserTable />
              </TabPanel>
              <TabPanel>
                <TeamTable />
              </TabPanel>
              <TabPanel>
                <LeagueTable />
              </TabPanel>
              <TabPanel>
                <ActivityTable />
              </TabPanel>
            </>
          ) : null}
          <TabPanel>
            <LeaguesTables />
          </TabPanel>
        </StyledTabs>
      </PageContainer>
      <Footer />
    </>
  )
}

export default Admin

const PageContainer = styled.div`
  padding: 20px;
  margin: 0 auto;
  max-width: 1200px;
`

const StyledTabs = styled(Tabs)`
  .react-tabs__tab-list {
    border-bottom: 2px solid #ff4500;
    display: flex;
    justify-content: space-around;
    background: linear-gradient(120deg, #000000ff 60%, #1a0f08 100%);
    border-radius: 12px 12px 0 0;
  }

  .react-tabs__tab {
    padding: 12px 15px;
    cursor: pointer;
    color: #fff;
    transition: all 0.3s ease;
    border: 1px solid transparent;
    border-radius: 12px 12px 0 0;

    &:hover {
      border: 1px solid #ff6b35;
      box-shadow: inset 0 0 4px 0.5px #ff6b35;
    }

    &--selected {
      border: 2px solid #ff6b35;
      background: linear-gradient(120deg, #000000ff 60%, #2a1510 100%);
      color: #ff6b35;
      box-shadow: 0 0 8px 1px #ff6b35;
      border-radius: 12px 12px 0 0;
    }
  }

  .react-tabs__tab-panel {
    background: linear-gradient(120deg, #000000ff 60%, #000000ff 100%);
    color: #fff;
    padding: 12px 15px;
    border: 2px solid #ff4500;
    border-top: none;
    box-shadow: 0 0 4px 0.5px #ff4500;
    border-radius: 0 0 12px 12px;
  }
`
